var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentRejected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.866 14.2446C14.72 14.3845 14.528 14.4554 14.336 14.4554C14.143 14.4554 13.952 14.3845 13.805 14.2446L11.999 12.5129L10.198 14.2388C9.905 14.5196 9.43 14.5196 9.137 14.2388C8.845 13.958 8.845 13.5038 9.137 13.223L10.938 11.497L9.136 9.76917C8.843 9.48838 8.843 9.03413 9.136 8.75334C9.429 8.47254 9.903 8.47254 10.196 8.75334L11.998 10.4803L13.8 8.75429C14.093 8.4735 14.567 8.4735 14.86 8.75429C15.153 9.03413 15.153 9.48934 14.86 9.77013L13.059 11.497L14.866 13.2278C15.159 13.5086 15.159 13.9638 14.866 14.2446ZM12 2.39575C6.762 2.39575 2.5 6.47921 2.5 11.4999C2.5 16.5197 6.762 20.6041 12 20.6041C17.238 20.6041 21.5 16.5197 21.5 11.4999C21.5 6.47921 17.238 2.39575 12 2.39575Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRejected);
export default __webpack_public_path__ + "static/media/DOCUMENT_REJECTED.480e635366840ef0418cedf33f738c7c.svg";
export { ForwardRef as ReactComponent };